import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {TemplateFolderShare} from "../../template/shared/template-folder-share";
import {TemplateFolderShareService} from "../../template/shared/template-folder-share.service";

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss']
})
export class ShareModalComponent implements OnInit {

  @ViewChild('urlCopied') popover: NgbPopover;

  @Input() folder;

  sharing = false;

  popoverTimeout;
  constructor(public activeModal: NgbActiveModal, private templateFolderShareService: TemplateFolderShareService) {}

  ngOnInit() {
  }

  yes() {
    this.activeModal.close('yes');
  }

  toggleShareSwitch(toggle) {
    console.log("toggle: ", toggle);
    if(toggle) {
      this.shareFolder()
    } else {
      this.unShareFolder();
    }
  }

  shareFolder() {
    this.sharing = true;
    this.templateFolderShareService.create(this.folder).then((share: TemplateFolderShare) => {
      this.sharing = false;
    }).catch((err) => {
      this.sharing = false;
    });
  }

  unShareFolder() {
    this.sharing = true;
    this.templateFolderShareService.delete(this.folder).then(() => {
      this.sharing = false;
    }).catch((err) => {
      this.sharing = false;
    });
  }

  popoverOpen() {
    clearTimeout(this.popoverTimeout);
  }

  delayedPopoverClose() {
    this.popoverTimeout = setTimeout(() => {
      this.popover.close();
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/share-modal/share-modal.component.ts